import React, { createContext, useState } from 'react'
import useTasks from '../../hooks/useTasks'
import './Project.css'
import TodoBacklog from './TodoBacklog'
import TodoDone from './TodoDone'
import TodoLab from './TodoLab'
import TodoComingUpNext from './TodoComingUpNext'
import TodoNow from './TodoNow'
import TodoResource from './TodoResource'

export const Priority = {
  Now: 'Now',
  ComingUpNext: 'ComingUpNext',
  Backlog: 'Backlog',
  None: 'None'
}

export const Progress = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  Done: 'Done'
}

export const LifeCycle = {
  Code: 'Code',
  Design: 'Design',
  Test: 'Test',
  Lab: 'Lab'
}

export const ItemType = {
  Task: 'Task',
  Resource: 'Resource'
}

export const TodoContext = createContext();

// const hardCodedTasks = [
//   {
//     text: `https://css-tricks.com/snippets/css/a-guide-to-flexbox`
//   },
//   {
//     text: `https://tympanus.net/Tutorials/CircularNavigation/index2.html`
//   },
//   {
//     text: `https://stackabuse.com/how-to-scroll-to-top-in-react-with-a-button-component/`
//   },
// ];



export default function Project() {  

  const {tasks, setTasks} = useTasks(); // hardCodedTasks

  const [isPopeyeOn, setPopeyeOn] = useState(false);

  const updateTask = (modifiedTask) => {
    setTasks(tasks.map(task => task.id === modifiedTask.id ? {...task, ...modifiedTask}: {...task}));
  }

  return (
    <TodoContext.Provider value={{tasks, setTasks, updateTask, isPopeyeOn, setPopeyeOn}}>
    <div className='project'>
      <div style={{fontSize: '3em', fontStyle:'italic', fontFamily: 'monospace', textDecorationStyle: 'wavy', display: 'flex'}}>
        <div style={{border: 'none', transform: 'rotate(-20deg)'}}>Config</div>
      </div>

      <div className='projectPane'>
        <div className='leftPane'>
          <TodoNow/>
          <TodoComingUpNext />
          <TodoBacklog />          
        </div>
        <div className='rightPane'>
          <TodoDone/>
          <TodoLab />
          <TodoResource />
        </div>
      </div>

      <div className='resources'>
      </div>
    </div>
    </TodoContext.Provider>
  )
}
